<section class="c-section c-section--first c-section--last c-section--open c-section--static">
    <div class="c-section__header">
        <h1 class="c-section__title c-section__title--sm">
            {{ 'Services.Other.Feedback_Clients' | translate }}
        </h1>
    </div>

    <div class="c-section__content">
        <div *ngIf="vm.feedbacks?.length > 0">
            <div class="o-grid o-grid--wrap">
                <div *ngFor="let feedback of vm.feedbacks" class="o-grid__cell o-grid__cell--w-33">
                    <div class="c-card u-ost-md feedback-card">
                        <div class="o-grid o-grid--wrap o-grid--middle">
                            <!-- Avatar -->
                            <div class="o-grid__cell o-grid__cell--w-fixed">
                                <div class="c-thumb">
                                    <div class="c-image c-image--bg c-image--round c-image--sm"
                                         [ngStyle]="{'background-image':'url(https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/avatar-01.svg)'}"
                                    ></div>
                                </div>
                            </div>

                            <!-- Feedback Info -->
                            <div class="o-grid__cell o-grid__cell--fill">
                                <p class="c-text c-text--bold u-osr-md">
                                  <span>
                                    {{ feedback.alias ? feedback.alias : feedback.rater.firstname + ' ' + feedback.rater.lastname }}
                                  </span>
                                </p>

                                <div class="feedback-header">
                                    <item-rating [model]="feedback.rating" [maxRating]="5" [size]="'sm'"></item-rating>
                                    <span class="c-text c-text--gray u-osr-xs">
                                        {{ feedback.created | date: 'dd MMM yyyy' }}
                                    </span>
                                </div>

                                <p class="c-text u-osr-md feedback-comment" style="margin-top: 8px;">
                                    {{ feedback.comment }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- View More -->
                <div class="o-grid__cell o-grid__cell--w-100 u-no-p"
                        style="margin-top: 10px; text-align: center;"
                        *ngIf="!vm.endReached">
                    <a id="viewMore" (click)="vm.getFeedbacks(false, true)"
                       style="cursor: pointer; text-decoration: none;">
                        <p class="c-text c-text--main u-osb-xs">
                            {{ 'Services.Button.ShowMore' | translate }}
                        </p>
                    </a>
                </div>
            </div>
        </div>

        <div *ngIf="vm.feedbacks?.length == 0">
            <p class="c-text">{{ 'Services.Other.No_Feedback' | translate }}</p>
        </div>
        <loader-overlay *ngIf="vm.loading"></loader-overlay>
    </div>
</section>
